import { Injectable } from "@angular/core";
import { HttpClient, HttpHeaders } from "@angular/common/http";

import { CONSTANTS } from "../constants/constants";
import { environment } from "../../../environments/environment";

@Injectable({
  providedIn: "root",
})
export class ShipDocumentService {
  constructor(private readonly http: HttpClient) {}

  headers = {
    headers: new HttpHeaders({
      "Content-Type": "application/json",
    }),
  };

  public getShipDocuments(poolId: number) {
    let url =
      environment.BASE_API_URL + CONSTANTS.API.SHIP_DOCUMENT.SHIP_DOCUMENTS;
    return this.http.get<any>(url, {
      ...this.headers,
      params: { poolId: poolId.toString() },
    });
  }
}
